import "../../pages/new/new.scss"

import React, { useState, useEffect, useRef} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import { useLocation } from 'react-router-dom';

export const ThesisSubmission = () => {
    const [file, setFile] = useState(null);
  const [presentationFile, setPresentationFile] = useState(null);
  const [presentationVideo, setPresentationVideo] = useState(null);
  const [turnitin, setTurnitin] = useState(null);
  const [loading, setLoading] = useState(false);

  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const fileInputRef3 = useRef(null);
  const fileInputRef4 = useRef(null);
    const { id,submissionId, report_type, report_month,announcementId } = useParams();
    const [studentId] = useState(localStorage.getItem('studentId'));
    const [submission, setSubmission] = useState({
        dateSubmitted: '',
        id: '',
        isFeedbackByReviewer1: '',
        isFeedbackByReviewer2: '',
        isSubmitted: '',
        modifiedAt: '',
        reportLink: '',
        folderLink: '',
        reportType: report_type?report_type:'',
        
        announcementId: announcementId?announcementId:null,
        reportMonth: report_month==='null'?null:report_month,
        reviewerId1: '',
        reviewerId2: '',
        studentId: ''
    });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [viewMode, setViewMode] = useState(false);
    const [fileLinks, setFileLinks] = useState({});

    const isDriveLink = (value) =>
        typeof value === "string" && value.startsWith("http");

    const fetchSubmission = async (id) => {
        try {
            const response = await axiosInstance.get(`/getSubmissionById?id=${id}`);
          //  console.log(response.data.data);
            setSubmission(response.data.data); // Set submission details from API response
        } catch (error) {
            console.error('Error fetching submission:', error);
        }
    };
    useEffect(() => {
        if (id) {
            const path = window.location.pathname;
            if (path.includes('view-thesis-details')) {
                setViewMode(true);
            }
            fetchSubmission(id);
            // Set mode to edit if submissionId is present
        } else {
            setViewMode(false);
        }
    }, [id]);

    // Files submitted via upload (rather than a pasted drive link) have no usable
    // URL in submission.* - fetch presigned download links for those instead.
    useEffect(() => {
        if (!id) return;

        const fetchFileLinks = async () => {
            try {
                const statusRes = await axiosInstance.get(`/files/status/${id}`);
                const uploaded = statusRes.data.data || {};
                const newLinks = {};

                for (const type in uploaded) {
                    if (!uploaded[type]) continue;
                    try {
                        const res = await axiosInstance.get("/files/presign-download", {
                            params: { thesisStatusId: id, fileType: type }
                        });
                        newLinks[type] = res.data.data.downloadUrl;
                    } catch (e) {
                        console.error(`Failed to fetch link for ${type}`, e);
                    }
                }

                setFileLinks(newLinks);
            } catch (err) {
                console.error("Error fetching file status", err);
            }
        };

        fetchFileLinks();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSubmission({ ...submission, [name]: value || '' });
        setErrors({ ...errors, [name]: '' });
    };

    const goBack = (e) => {
        navigate('/thesis/');
    };

    const validateForm = () => {
        const newErrors = {};
        if(!viewMode){
            if (!file ) {
                newErrors.reportLink = 'Report File is required';
              }
              if (!presentationFile || !presentationFile) {
                newErrors.presentationLink = 'Presentation File is required';
              }
              if (!presentationVideo || !presentationVideo) {
                newErrors.presentationVideoLink= 'Presentation Video is required';
              }
              if(submission.reportType!=='Monthly' && !turnitin){
                newErrors.turnitin='Turnitin is required';
              }
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        var response = '';
        try {
            setLoading(true);
            if (viewMode) {
                navigate('/thesis');
            }
            
        } catch (error) {
            console.log('Error saving submission. Please try again later.');
            console.log(error);
        } finally {
            setLoading(false);
        }

    };
    


    return (
        <div>
                  {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
            <div className="top">
                <h1>{'View Submission'}</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form onSubmit={handleSubmit}>

                        {/* <div className="formInput">
                            <label>Report Type</label>
                            <input type="text"
                                name="reportType"
                                value={submission.reportType}
                                readOnly={true}
                                className={errors.reportType ? 'error' : ''} />
                            {errors.reportType && <div className="error-text">{errors.reportType}</div>}
                        </div>
                        {submission.reportMonth && submission.reportMonth!= null && <div className="formInput">
                            <label>Report Month</label>
                            <input type="text"
                                name="reportMonth"
                                value={submission.reportMonth}
                                readOnly={true}
                                className={errors.reportMonth ? 'error' : ''} />
                            {errors.reportMonth && <div className="error-text">{errors.reportMonth}</div>}
                        </div>} */}


                        {/* {!viewMode && <div className="formInput">
              Upload Report File {' '}
              <input type="file" name="reportLink" ref={fileInputRef1} onChange={handleFileChange} />
              {submission.reportLink && (
                                <div>
                                    <a href={submission.reportLink} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Link
                                    </a>
                                </div>
                            )}
              {errors.reportLink && <div className="error-text">{errors.reportLink}</div>}
            </div>}

            {!viewMode && <div className="formInput">
              Upload Presentation File {' '}
              <input type="file" name="presentationLink" ref={fileInputRef2} onChange={handlePresentationFileChange} />
              {submission.presentationLink && (
                                <div>
                                    <a href={submission.presentationLink} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Presentation Link
                                    </a>
                                </div>
                            )}
              {errors.presentationLink && <div className="error-text">{errors.presentationLink}</div>}

            </div>}

            {!viewMode && <div className="formInput">
              Upload Presentation Video {' '}
              <input type="file" name="presentationVideoLink" ref={fileInputRef3} onChange={handlePresentationVideoChange}
              value={presentationVideo} />
              {submission.presentationVideoLink && (
                                <div>
                                    <a href={submission.presentationVideoLink} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Video Link
                                    </a>
                                </div>
                            )}
              {errors.presentationVideoLink && <div className="error-text">{errors.presentationVideoLink}</div>}

            </div>}


            {!viewMode &&  <div className="formInput">
              Upload Turnitin {' '}
              <input type="file" name="turnitin" ref={fileInputRef4} onChange={handleTurnitinChange} />
              {submission.turnitin && (
                                <div>
                                    <a href={submission.turnitin} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Turnitin Link
                                    </a>
                                </div>
                            )}
              {errors.turnitin && <div className="error-text">{errors.turnitin}</div>}

            </div>} */}

            {viewMode && <div className="formInput">
                            <label htmlFor="linkInput">Folder Link</label>
                            <input
                                name="folderLink"
                                type="url"
                                id="linkInput"
                                value={submission.folderLink}
                                onChange={handleChange}
                                readOnly={viewMode}
                                placeholder=""
                                className={errors.folderLink ? 'error' : ''}
                            />
                            {submission.folderLink && (
                                <div>
                                    <a href={submission.folderLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.folderLink && <div className="error-text">{errors.folderLink}</div>}
                        </div>}

            {viewMode && <div className="formInput">
                            <label htmlFor="linkInput">Report Link</label>
                            {isDriveLink(submission.reportLink) && (
                                <input
                                    name="reportLink"
                                    type="url"
                                    id="linkInput"
                                    value={submission.reportLink}
                                    onChange={handleChange}
                                    readOnly={viewMode}
                                    placeholder=""
                                    className={errors.reportLink ? 'error' : ''}
                                />
                            )}
                            {(isDriveLink(submission.reportLink) || fileLinks.Report) && (
                                <div>
                                    <a href={isDriveLink(submission.reportLink) ? submission.reportLink : fileLinks.Report} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.reportLink && <div className="error-text">{errors.reportLink}</div>}
                        </div>}
                        {viewMode && <div className="formInput">
                            <label htmlFor="linkInput">Presentation Link</label>
                            {isDriveLink(submission.presentationLink) && (
                                <input
                                    name="presentationLink"
                                    type="url"
                                    id="linkInput"
                                    value={submission.presentationLink}
                                    onChange={handleChange}
                                    readOnly={viewMode}
                                    placeholder=""
                                    className={errors.presentationLink ? 'error' : ''}
                                />
                            )}
                            {(isDriveLink(submission.presentationLink) || fileLinks.Presentation_File) && (
                                <div>
                                    <a href={isDriveLink(submission.presentationLink) ? submission.presentationLink : fileLinks.Presentation_File} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.presentationLink && <div className="error-text">{errors.presentationLink}</div>}
                        </div>}

                        {viewMode && <div className="formInput">
                            <label htmlFor="linkInput">Presentation Video Link</label>
                            {isDriveLink(submission.presentationVideoLink) && (
                                <input
                                    name="presentationVideoLink"
                                    type="url"
                                    id="linkInput"
                                    value={submission.presentationVideoLink}
                                    onChange={handleChange}
                                    readOnly={viewMode}
                                    placeholder=""
                                    className={errors.presentationVideoLink ? 'error' : ''}
                                />
                            )}
                            {(isDriveLink(submission.presentationVideoLink) || fileLinks.Presentation_Video) && (
                                <div>
                                    <a href={isDriveLink(submission.presentationVideoLink) ? submission.presentationVideoLink : fileLinks.Presentation_Video} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.presentationVideoLink && <div className="error-text">{errors.presentationVideoLink}</div>}
                        </div>}

                        {viewMode &&  <div className="formInput">
                            <label htmlFor="linkInput">Turnitin</label>
                            {isDriveLink(submission.turnitin) && (
                                <input
                                    name="turnitin"
                                    type="url"
                                    id="linkInput"
                                    value={submission.turnitin}
                                    onChange={handleChange}
                                    readOnly={viewMode}
                                    placeholder=""
                                    className={errors.turnitin ? 'error' : ''}
                                />
                            )}
                            {(isDriveLink(submission.turnitin) || fileLinks.Turnitin) && (
                                <div>
                                    <a href={isDriveLink(submission.turnitin) ? submission.turnitin : fileLinks.Turnitin} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.turnitin && <div className="error-text">{errors.turnitin}</div>}
                        </div>}

                        <div className="buttons">
                            {/* {!viewMode && <button type="submit">{editMode ? 'Update' : 'Save'}</button>} */}
                            <button onClick={goBack}>Back</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};